import PageHero from "@/components/PageHero";
import CTASection from "@/sections/CTASection";
import ProcessTimeline from "@/sections/ProcessTimeline";
import { SERVICES } from "@/data/services";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

const HERO_IMG = "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=2400";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        overline="Services"
        title={<>13 disciplines.<br /><span className="italic font-light text-gold">One integrated team.</span></>}
        subtitle="Engineering, architecture, project management, hospitality, retail, environment, art and business — every consultancy your project needs, without hand-offs."
        image={HERO_IMG}
        breadcrumbs={[{ label: "Services" }]}
      />

      <section className="bg-white py-24 sm:py-32">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.slug}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
                  className="group bg-white"
                >
                  <Link
                    to={`/services/${s.slug}`}
                    className="block p-8 h-full relative overflow-hidden"
                    data-testid={`services-page-card-${s.slug}`}
                  >
                    <div className="absolute inset-0 bg-navy translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
                    <div className="relative">
                      <div className="flex items-center justify-between">
                        <div className="w-12 h-12 grid place-items-center border border-slate-200 text-emerald-brand group-hover:border-gold group-hover:text-gold transition-colors">
                          <Icon size={20} strokeWidth={1.5} />
                        </div>
                        <span className="overline text-slate-400 group-hover:text-gold transition-colors">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                      </div>
                      <h3 className="mt-8 font-display font-bold text-xl text-navy group-hover:text-white transition-colors">
                        {s.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-slate-brand group-hover:text-white/75 transition-colors">
                        {s.short}
                      </p>
                      <div className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-semibold text-emerald-brand group-hover:text-gold transition-colors">
                        Learn more <ArrowUpRight size={14} />
                      </div>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <ProcessTimeline />
      <CTASection />
    </div>
  );
}
